<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: zh
 * @Date: 2021-11-19 09:26:38
 * @LastEditors: yfw
 * @LastEditTime: 2023-05-22 16:38:06
-->
<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/kportalbg.jpg')})`}"></div>
    </div>
    <div class="inner-pannel zh-font">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <div style="height:55px;"></div>
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
              <p class="right-color">{{$t('kportal.content1.title')}}</p>
              <div style="height:20px"></div>
              <p class="link color-w" @click="goTo($t('kportal.content1.urls[0].url'))">{{$t('kportal.content1.urls[0].name')}}<i class="el-icon-arrow-right"></i></p>
              <div style="height:20px"></div>
              <p class="link color-w" @click="goTo($t('kportal.content1.urls[1].url'))">{{$t('kportal.content1.urls[1].name')}}<i class="el-icon-arrow-right"></i></p>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-box ani animate__animated animate__fadeInUp">
        <div style="height:55px;"></div>
        <p class="right-color">{{$t('kportal.content2.title')}}</p>
        <div style="height:20px"></div>
        <p class="link color-w" @click="goTo($t('kportal.content2.urls[0].url'))">{{$t('kportal.content2.urls[0].name')}}<i class="el-icon-arrow-right"></i></p>
        <div style="height:20px"></div>
        <p class="link color-w" @click="goTo($t('kportal.content2.urls[1].url'))">{{$t('kportal.content2.urls[1].name')}}<i class="el-icon-arrow-right"></i></p>
      </div>
    </div>
  </div>
</template>
<script>
export default({
  data() {
    return {

    }
  },
  methods: {
    goTo(path) {
      window.open(path,'_blank')
    }
  }
})
</script>

<style scoped>
  .topPoint::after {
      width: 25px;
      height: 25px;
      content: "";
      position: absolute;
      background: #ed6d00;
      border-radius: 50%;
      z-index: 1;
      top: -12.5px;
      right: -12.5px;
  }
  .right-color{
    color: #ffffff;
  }
  .link{
    cursor:pointer;
  }
  .color-w{
    color: #ed6d00;
  }
  .bottom-box{
    padding-left: 50px;
  }
  .container{
    font-family: "Lato";
  }
  @media screen and (max-width:768px) {
    .content-page{
      padding-left: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/kportalIndex/kportalIndex.vue